import { Extra } from "./Extra";
import * as THREE from "three";
import { MathUtils } from "three";
import { envMap, zipNormal } from "../../assets/materials";
import { ExtraType } from "../../../entities/LedExtras";
var degToRad = MathUtils.degToRad;
export class AdjustableParapet extends Extra {
    /** Creates the zipScreen sides according to the user's choice **/
    createPanel() {
        if (this.formData.left.extra === ExtraType.PARAPET || this.formData.left.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // LEFT blue
            this.createParapet(this.dimension.left, "LEFT");
        }
        if (this.formData.right.extra === ExtraType.PARAPET || this.formData.right.extra === ExtraType.PARAPET_ZIPSCREEN) {
            //RIGHT Green
            this.createParapet(this.dimension.right, "RIGHT");
        }
        if (this.formData.close.extra === ExtraType.PARAPET || this.formData.close.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // CloseSide - WHITE
            this.createParapet(this.dimension.close, "CLOSE");
        }
        if (this.formData.far.extra === ExtraType.PARAPET || this.formData.far.extra === ExtraType.PARAPET_ZIPSCREEN) {
            // WALL Purple
            this.createParapet(this.dimension.far, "FAR");
        }
    }
    /** The space between 2 leg is 1 frame here. Usually 1 module means 1 frame however if the width is more than 600 or in PVC 450 and 900 there is another frame inside a module
     * We get the frame from the side object automatically
     * **/
    createParapet(side, name) {
        // When we have walls return
        if (this.scene.getActualSide(name).wall === true) {
            return;
        }
        let rotation = side.rotationY;
        const pos = new THREE.Vector3().copy(side.position);
        // Remove the pillar's width from the frame sizes
        const edgeWidth = this.formData.measuredModel.model.edgeWidth;
        let width = side.length - edgeWidth * 2 - edgeWidth * (side.frames - 1);
        let startingPos = pos.x - width / 2 - edgeWidth / 2 * (side.frames - 1);
        let startingPosZ = pos.z - width / 2 - edgeWidth / 2 * (side.frames - 1);
        const frameSize = width / side.frames;
        this.createWindow(rotation, pos, name, width, startingPos, startingPosZ, frameSize, side, edgeWidth);
        this.createParapetPillars(rotation, pos, name, width, startingPos, startingPosZ, frameSize, side, edgeWidth);
    }
    createParapetPillars(rotation, pos, name, width, startingPos, startingPosZ, frameSize, dimension, edgeWidth) {
        const scale = new THREE.Vector3(1, 1, 1);
        const quatRotation = new THREE.Quaternion(0, 0, 0);
        const mat = this.scene.materialPicker.getMaterial();
        mat.metalness += 0.02;
        const depth = edgeWidth / 3.2;
        const height = 257 - this.formData.measuredModel.model.edgeHeight / 2;
        const pillarGeom = new THREE.BoxGeometry(edgeWidth / 2, height, depth).rotateY(degToRad(rotation));
        const pillarMesh = new THREE.InstancedMesh(pillarGeom, mat, dimension.frames * 2);
        let adjustDepth = depth;
        for (let x = 0; x <= dimension.frames * 2; x += 2) {
            let mainPos = startingPos + frameSize * x / 2 + edgeWidth * x / 2;
            let mainPosZ = startingPosZ + frameSize * x / 2 + edgeWidth * x / 2;
            let position;
            for (let i = 0; i < 2; i++) {
                let adjust;
                if (i === 0)
                    adjust = edgeWidth / 4;
                else
                    adjust = -edgeWidth / 4;
                if (this.rotated === true) {
                    if (rotation === 0) {
                        if (name === "CLOSE")
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z + adjustDepth);
                        else
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z - adjustDepth);
                    }
                    else {
                        if (name === "RIGHT")
                            position = new THREE.Vector3(pos.x + adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                        else
                            position = new THREE.Vector3(pos.x - adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                    }
                }
                else {
                    if (rotation === 0) {
                        if (name === "RIGHT")
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z - adjustDepth);
                        else
                            position = new THREE.Vector3(mainPos + adjust + frameSize * i, height / 2, pos.z + adjustDepth);
                    }
                    else {
                        if (name === "CLOSE")
                            position = new THREE.Vector3(pos.x + adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                        else
                            position = new THREE.Vector3(pos.x - adjustDepth, height / 2, mainPosZ + adjust + frameSize * i);
                    }
                }
                pillarMesh.setMatrixAt(x + i, new THREE.Matrix4().compose(position, quatRotation, scale));
            }
        }
        this.scene.threeScene.add(pillarMesh);
    }
    createWindow(rotation, pos, name, width, startingPos, startingPosZ, frameSize, dimension, edgeWidth) {
        const scale = new THREE.Vector3(1, 1, 1);
        const quatRotation = new THREE.Quaternion(0, 0, 0);
        // Glass material for the parapet
        const mat = this.scene.materialPicker.getMaterial();
        mat.opacity = 0.5;
        mat.roughness = 0.1;
        mat.envMap = envMap;
        mat.envMapIntensity = 1;
        mat.transparent = true;
        const glassGeom = new THREE.BoxGeometry(frameSize, 260, 2).rotateY(degToRad(rotation));
        const glassMesh = new THREE.InstancedMesh(glassGeom, mat, dimension.frames);
        const upperEdgeMat = this.scene.materialPicker.getMaterial();
        const lowerEdgeMat = this.scene.materialPicker.getMaterial();
        upperEdgeMat.polygonOffset = true;
        upperEdgeMat.polygonOffsetFactor = -1;
        upperEdgeMat.normalMap = zipNormal;
        const depth = edgeWidth / 3;
        let adjustDepthUpperEdge = 2.5;
        const upperEdgeGeom = new THREE.BoxGeometry(frameSize, 10, 10).rotateY(degToRad(rotation));
        const lowerEdgeGeom = new THREE.BoxGeometry(dimension.length, 5, 4).rotateY(degToRad(rotation));
        const lowerEdgeMesh = new THREE.InstancedMesh(lowerEdgeGeom, lowerEdgeMat, 3);
        const upperEdgeMesh = new THREE.InstancedMesh(upperEdgeGeom, upperEdgeMat, dimension.frames);
        const height = 253 - this.formData.measuredModel.model.edgeHeight / 2;
        for (let x = 0; x < dimension.frames; x++) {
            let mainPos = startingPos + frameSize * x + edgeWidth * x + frameSize / 2;
            let mainPosZ = startingPosZ + frameSize * x + edgeWidth * x + frameSize / 2;
            let position;
            let position2;
            if (this.rotated === true) {
                if (rotation === 0) {
                    if (name === "CLOSE") {
                        position = new THREE.Vector3(mainPos, 130, pos.z + depth);
                        position2 = new THREE.Vector3(mainPos, 180, pos.z + adjustDepthUpperEdge);
                    }
                    else {
                        position = new THREE.Vector3(mainPos, 130, pos.z - depth);
                        position2 = new THREE.Vector3(mainPos, 180, pos.z - adjustDepthUpperEdge);
                    }
                }
                else {
                    if (name === "RIGHT") {
                        position = new THREE.Vector3(pos.x + depth, 130, mainPosZ);
                        position2 = new THREE.Vector3(pos.x + adjustDepthUpperEdge, 180, mainPosZ);
                    }
                    else {
                        position = new THREE.Vector3(pos.x - depth, 130, mainPosZ);
                        position2 = new THREE.Vector3(pos.x - adjustDepthUpperEdge, 180, mainPosZ);
                    }
                }
            }
            else {
                if (rotation === 0) {
                    if (name === "RIGHT") {
                        position = new THREE.Vector3(mainPos, 130, pos.z - depth);
                        position2 = new THREE.Vector3(mainPos, 180, pos.z - adjustDepthUpperEdge);
                    }
                    else {
                        position = new THREE.Vector3(mainPos, 130, pos.z + depth);
                        position2 = new THREE.Vector3(mainPos, 180, pos.z + adjustDepthUpperEdge);
                    }
                }
                else {
                    if (name === "CLOSE") {
                        position = new THREE.Vector3(pos.x + depth, 130, mainPosZ);
                        position2 = new THREE.Vector3(pos.x + adjustDepthUpperEdge, 180, mainPosZ);
                    }
                    else {
                        position = new THREE.Vector3(pos.x - depth, 130, mainPosZ);
                        position2 = new THREE.Vector3(pos.x - adjustDepthUpperEdge, 180, mainPosZ);
                    }
                }
            }
            if (x === 0) {
                let posX = dimension.position.x;
                let posZ = position.z;
                if (this.rotated === true) {
                    if (name === "RIGHT" || name === "LEFT") {
                        posX = position.x;
                        posZ = dimension.position.z;
                    }
                }
                else {
                    if (name === "CLOSE" || name === "FAR") {
                        posX = position.x;
                        posZ = dimension.position.z;
                    }
                }
                lowerEdgeMesh.setMatrixAt(0, new THREE.Matrix4().compose(new THREE.Vector3(posX, 87, posZ), quatRotation, scale));
                lowerEdgeMesh.setMatrixAt(1, new THREE.Matrix4().compose(new THREE.Vector3(posX, 175, posZ), quatRotation, scale));
                lowerEdgeMesh.setMatrixAt(2, new THREE.Matrix4().compose(new THREE.Vector3(posX, 15, posZ), quatRotation, scale));
            }
            upperEdgeMesh.setMatrixAt(x, new THREE.Matrix4().compose(new THREE.Vector3(position2.x, height, position2.z), quatRotation, scale));
            upperEdgeMesh.renderOrder = 1;
            glassMesh.setMatrixAt(x, new THREE.Matrix4().compose(position, quatRotation, scale));
        }
        this.scene.threeScene.add(glassMesh, upperEdgeMesh, lowerEdgeMesh);
    }
}
